// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewActionTableCell_wrapper__7TnT1","centered":"ViewActionTableCell_centered__eJeZa"};